import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_URL || 'https://debestcollege-6e2a2a9de346.herokuapp.com/api';

const api = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  },
  withCredentials: true,
  timeout: 600000, // 10 minutes timeout for large file uploads
  maxContentLength: Infinity,
  maxBodyLength: Infinity
});

api.interceptors.request.use(
  config => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  error => Promise.reject(error)
);

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      const { status, data } = error.response;
      switch (status) {
        case 401:
          // Handle 401: Unauthorized (e.g., token expired or invalid)
          alert(' Please log in again.');
          localStorage.removeItem('token');
          // Prefer SPA-safe navigation to avoid hard cross-context frame navigations
          if (typeof window !== 'undefined') {
            window.history.pushState({}, '', '/login');
            window.dispatchEvent(new PopStateEvent('popstate'));
          }
          break;
        case 403:
          // Handle 403: Forbidden (user is authenticated but lacks permission)
          alert(data?.error || 'Access Denied: You do not have permission to perform this action or access this resource.');
          break;
        default:
          // Handle other status codes
          console.error('API Error:', error);
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Network Error:', error);
    } else {
      // Something happened in setting up the request
      console.error('Request Error:', error);
    }
    return Promise.reject(error);
  }
);

export default api;
